import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import {
  PageHeader,
  Screen,
  ScreenBody,
  SectionHead,
  Stack,
} from '@leanin/ui';
import { fetchMySessions } from '@/lib/queries/account';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { ChangePasswordClient } from './-components/ChangePasswordClient';
import { SessionsSection } from './-components/SessionList';
import { TwoFactorClient } from './-components/TwoFactorClient';

export const Route = createFileRoute('/_authed/settings/sessions/')({
  component: SettingsSessionsPage,
});

function SettingsSessionsPage() {
  const query = useQuery({
    queryKey: identityKeys.sessions(),
    queryFn: fetchMySessions,
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        title="Login and devices"
        message="Could not load sessions."
      />
    );
  }
  if (query.isLoading) return null;
  return (
    <Screen>
      <ScreenBody gap="2xl">
        <PageHeader
          eyebrow="Settings"
          title="Login and devices"
          subtitle="Active sign-ins on your account. Revoke any you don't recognize."
          back={{ label: 'Settings', href: '/settings' }}
        />
        <Stack gap="md">
          <SectionHead title="Active sessions" />
          <SessionsSection />
        </Stack>

        <ChangePasswordClient />

        <TwoFactorClient />
      </ScreenBody>
    </Screen>
  );
}
